import React from "react";
import {
    ConnectedEmployerMatching,
    ConnectedManualEmployerMatching,
} from "../../common/MatchingGift";

/**
 * @param {object} props
 * @param {number} props.controlId
 * @param {boolean} props.isManualMatch
 * @returns {React.JSX.Element}
 */
const EmployerMatchingControl = ({ controlId, isManualMatch }) =>
    isManualMatch ? (
        <ConnectedManualEmployerMatching controlId={controlId} />
    ) : (
        <ConnectedEmployerMatching controlId={controlId} />
    );

export default EmployerMatchingControl;
